import React from "react";
import timeTrailsEmpty from "../../../../../assets/timetrails/time_trails_empty.svg";
import "./EmployeeActivityPage.css";

export const EmployeeActivityEmpty = ({ title = "No Submissions Found!" }) => {
  return (
    <div className="employeeActivityPage__emptyState">
      <div className="employeeActivityPage__emptyStateContent">
        <div className="employeeActivityPage__emptyStateImage">
          <img
            src={timeTrailsEmpty}
            alt={title}
            className="employeeActivityPage__emptyIllustration"
          />
        </div>
        <div className="employeeActivityPage__emptyStateText">
          <h2 className="employeeActivityPage__emptyTitle">{title}</h2>
        </div>
      </div>
    </div>
  );
};
